module.exports = __webpack_public_path__ + "img/logo.574288e0.png";